import { ONFIDO_APPLICANT_SDK, ONFIDO_CREATING_CHECK } from '@/constants/api';
import {
  GetOnFidoChecksQueryType,
  GetOnFidoChecksQueryVariables,
  getOnFidoCheckQuery,
} from '@/schemas/onfidoCheckStatus';

import { OnfidoSdkTokenResponseData } from '@/types/onfido';
import { getApolloClient } from '@/utils/apollo';
import { proxy, request } from '@/utils/request';
import { REQUEST_METHOD } from '@treyd-io/core/constants/request';

export const getOnfidoSdkToken = async () =>
  request<OnfidoSdkTokenResponseData>({
    url: ONFIDO_APPLICANT_SDK,
    method: REQUEST_METHOD.POST,
  });

export const createOnfidoCheck = async () =>
  request({
    url: ONFIDO_CREATING_CHECK,
    method: REQUEST_METHOD.POST,
  });

export namespace GetOnfidoCheck {
  export const server = async (userId: number, accessToken: string) => {
    const apolloClient = await getApolloClient(accessToken);
    return await apolloClient.query({
      query: getOnFidoCheckQuery,
      variables: { userId },
    });
  };

  export const client = async (userId: number) => {
    return proxy<GetOnFidoChecksQueryType, GetOnFidoChecksQueryVariables>({
      query: getOnFidoCheckQuery,
      variables: {
        userId,
      },
    });
  };
}
